module.exports = __webpack_public_path__ + "img/icon_plain_2.49ce1ea8.svg";